import axios from 'axios';
import { BACKEND_URL } from '../util/constants';

const apiUrl = process.env.BACKEND_URL;

export interface Catalog {
  type: string;
  title: string;
  slug: string;
  description: string;
  tags: string[];
  isFree?: boolean;
  isOnline: boolean;
  isDigital: boolean;
  category: string;
  targets: string[];
  department: string;
  departmentSections: string[];
  categorySlug: string;
  highlighted: boolean;
  score: number;
  imageUrl: string;
  icon: string;
  link: string;
  resultTotal: number;
}

interface params {
  accessToken?: string;
  query?: string;
  category?: string[];
  departmentSlug?: string;
  from?: number;
  max?: number;
}

export async function search({
  accessToken,
  query,
  category,
  departmentSlug,
  from,
  max,
}: params): Promise<Catalog[]> {
  const response = await axios.post(
    `${apiUrl}/v1/search`,
    {
      query,
      groups: ['CATALOG'],
      category,
      departmentSlug,
      from,
      max,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return response.data;
}

export interface Suggestion {
  title: string;
  slug: string;
}

export async function searchSuggestionsByTitle(
  value: string,
  limit: number
): Promise<Suggestion[]> {
  const response = await axios.get(
    `${BACKEND_URL}/v1/search/suggestions-by-title?q=${value}&limit=${limit}`
  );

  return response.data;
}

export interface CatalogCategory {
  id: string;
  slug: string;
  name: string;
  description: string;
  hidden: boolean;
  icon: string;
  mobileIcon: string;
  orderIndex: number;
  externalId: string;
}

export interface CatalogByDepartmentSection extends Omit<Catalog, 'category'> {
  category: CatalogCategory;
  name?: string;
}

export interface CatalogByDepartmentSectionResponse {
  data: CatalogByDepartmentSection[];
  resultTotal: number;
}

export async function getCatalogByDepartmentSectionIds(
  departmentSectionIds: string[],
  limit: number,
  offset: number
): Promise<CatalogByDepartmentSectionResponse> {
  const response = await axios.post(
    `${apiUrl}/v1/catalog/catalogs-per-department-sections`,
    {
      departmentSectionIds,
      resolveSharedReferences: true,
      limit,
      offset,
    }
  );
  return response.data;
}
